//@mui
import { FullBrand } from "~src/types/brand";
import CompetitorComparison from "../comparison";

export default function ComparisonReport({
  brandComparison,
}: {
  brandComparison: FullBrand[];
}) {
  return <CompetitorComparison fullBrand={brandComparison} />;
}
